import Localization from '~/assets/javascript/localization/Localization'
import Vue from 'vue'

export default function () {
  Vue.use(Localization);
}